module.exports = __webpack_public_path__ + "img/s1_t1_15.05722c20.jpeg";